import { getUser } from '../auth/authService';
import { getSessionModules, MODULES_KEY, setSessionItem } from '../session/sessionStore';
import * as tokenStorage from '../auth/tokenStorage';
import { getModulesFromToken, getProfileIdsFromToken } from '../auth/jwtClaims';
import { readLegacyCompatSession } from '../legacy/legacySession';

function resolveGrantedModules() {
  const stored = getSessionModules();
  if (stored.length > 0) {
    return stored;
  }

  const accessToken = tokenStorage.getAccessToken();
  if (!accessToken) {
    return [];
  }

  const fromToken = getModulesFromToken(accessToken);
  if (fromToken.length > 0) {
    setSessionItem(MODULES_KEY, JSON.stringify(fromToken));
  }

  return fromToken;
}

export function getGrantedModules() {
  return resolveGrantedModules();
}

export function hasModule(moduleName) {
  if (!moduleName) {
    return false;
  }

  const modules = getGrantedModules();
  return modules.some(
    (module) => String(module).trim().toLowerCase() === String(moduleName).trim().toLowerCase()
  );
}

export function getCurrentProfileIds() {
  const token = tokenStorage.getAccessToken();
  if (token && !tokenStorage.isExpired()) {
    const fromToken = getProfileIdsFromToken(token);
    if (fromToken.length > 0) {
      return fromToken;
    }
  }

  const user = getUser();
  if (user?.profileIds?.length > 0) {
    return user.profileIds.map(String);
  }

  const legacy = readLegacyCompatSession();
  if (!legacy.isLegacyAuthenticated) {
    return [];
  }

  if (legacy.alumnoCodigos === '-1') {
    return ['1'];
  }

  return (legacy.alumnoCodigos || '')
    .split(',')
    .map((code) => code.trim())
    .filter(Boolean);
}

export function hasProfileCode(profileCode) {
  const target = String(profileCode);
  return getCurrentProfileIds().some((id) => {
    const normalized = String(id);
    if (target === '1') {
      return normalized === '1' || normalized === '-1';
    }
    return normalized === target;
  });
}

export function canViewSistemaMenu() {
  return hasProfileCode('1') && hasModule('WWAuditoria');
}

export function canAccess(moduleName) {
  return hasModule(moduleName);
}
